import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function TitleUpdater({
    website_name,
    title: propsTitle
}) {
    const { t } = useTranslation();
    const location = useLocation();
    function removeLeadingDot(str) {
        return str.startsWith('.') ? str.slice(1) : str;
    }
    useEffect(() => {

        let locationSplit = location.pathname.split("/").filter((x) => x)
        let locationLanguage = removeLeadingDot(locationSplit.join('.'))
        let title = propsTitle ?? t(locationLanguage + ".")
        if (title) {
            document.title = `${title} ${website_name || ""}`;
        } else {
            document.title = `${website_name || "歡迎"}`;
        }
    }, [location]);

    return null; // 不渲染任何東西
}
export default TitleUpdater